import { render, staticRenderFns } from "./Lyric.vue?vue&type=template&id=5f7545b7&scoped=true&"
import script from "./Lyric.vue?vue&type=script&lang=js&"
export * from "./Lyric.vue?vue&type=script&lang=js&"
import style0 from "./Lyric.vue?vue&type=style&index=0&id=5f7545b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7545b7",
  null
  
)

export default component.exports